import {Button} from "@progress/kendo-react-buttons";
import useClientStore from "../../stores/ClientStore";
import useProjectStore from "../../stores/ProjectStore";

const Header = props => {

    const caption = props.caption
    // const client = props.client

    const {selectedClient, setSelectedClient} = useClientStore((state) => ({selectedClient: state.selectedClient, setSelectedClient: state.selectClient}))
    const {selectedProject} = useProjectStore((state) => ({selectedProject: state.selectedItem}))

    const onClose = props.onClose

    const closeClient = e => {
        setSelectedClient(null)
        props.navigateToRoute("/")
    }

    return(
        <>

            <div className="header">

                {/*<img src={config.IMG_URL + "logo_small2.png"} className="logo"  alt="logo"/>*/}

                <h2>{caption}</h2>

                {/*{client && <h2>{client.Name}</h2>}*/}
                {selectedClient && <div className="header-client-info">{selectedClient.Name}</div>}
                {selectedProject && <div className="header-client-info">{selectedProject.Name}</div>}

                {selectedClient && <div className="header-action">
                    <Button size={"medium"} themeColor={"warning"} onClick={closeClient}>Close Client</Button>
                </div>}


            </div>

        </>
    )
}

export default Header